/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */
export const environment = {
  production: true,
  apiUrl: "https://a314-users-dev.tc.avwaveinteractive.com/users",
  apiUrlProjectService:
    "https://a314-projects-dev.tc.avwaveinteractive.com/projects",
  urlStorage: "https://storage.googleapis.com/tc-avwave-dev/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};
